import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from '../../api/axiosClient';
import { Box, Grid, Typography } from '@mui/material';
import ProductCard from '../Composition/ProductCard';
import ErrorNotice from '../common/ErrorNotice';

const SearchResults = () => {
  const location = useLocation();
  const [searchResults, setSearchResults] = useState([]);
  const [error, setError] = useState('');
  const query = new URLSearchParams(location.search).get('q');

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (query) {
        try {
          const response = await axios.get(`/api/search/?q=${encodeURIComponent(query)}`);
          setSearchResults(response.data);
          setError('');
        } catch (err) {
          setError('Не удалось выполнить поиск. Попробуйте ещё раз.');
        }
      }
    };

    fetchSearchResults();
  }, [query]);

  return (
    <Box sx={{ p: 2 }}>
      <ErrorNotice>{error}</ErrorNotice>
      <Grid container spacing={2}>
        {query ? (
          searchResults.length > 0 ? (
            searchResults.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))
          ) : (
            !error && <Typography>Ничего не найдено</Typography>
          )
        ) : (
          <Typography>Введите запрос для поиска</Typography>
        )}
      </Grid>
    </Box>
  );
};

export default SearchResults;
